import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useHelpModalState } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';

const useHasLegalInsurance = (nextUrl: Array<string>) => {
  const { t } = useTranslation('has_legal_insurance');
  const history = useHistory();
  const { dispatchQuestion, appStore } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const [legalInsuranceUrl, packageUrl] = nextUrl;

  const onYes = () => {
    dispatchQuestion('hasLegalInsurance', true);
    appStore.partner?.partnerType == 'broker' && dispatchQuestion('reference', '');
    history.push(legalInsuranceUrl);
  };

  const onNo = async () => {
    dispatchQuestion('hasLegalInsurance', false);
    dispatchQuestion('legalInsurance', undefined);
    history.push(packageUrl);
  };

  return {
    classes: useStyles(),
    t,
    onYes,
    onNo,
    toggleHelpModal,
  };
};

export default useHasLegalInsurance;
